module.exports = __webpack_public_path__ + "img/ddae58e1636ca7f2b8f59bcbfad7460d.png";